var React = require('react');

function LiquorIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M246.74 13.98a7.5 7.5 0 0 0-6.78-4.3H7.5a7.5 7.5 0 0 0-5.79 12.27l89.36 108.39v99.94A7.5 7.5 0 0 0 101.9 237l50.21-24.89a7.5 7.5 0 0 0 4.17-6.7l.1-75.07 89.37-108.39a7.5 7.5 0 0 0 1-7.97zM143.1 122.88a7.5 7.5 0 0 0-1.72 4.75l-.1 73.1-35.2 17.46v-90.55a7.5 7.5 0 0 0-1.72-4.77L23.4 24.68h200.66l-80.96 98.2z"}));
}

LiquorIcon.displayName = "LiquorIcon";

LiquorIcon.defaultProps = {"viewBox":"0 0 247.46 247.46"};

module.exports = LiquorIcon;

LiquorIcon.default = LiquorIcon;
